import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { Paragraph, QuillText, Subheading } from '@treams/treams-ui';

export default function ReviewGoalsDisplay(props: {
	form: graphql.EvaluationSectionItem;
	item: graphql.EvaluationSubmissionItem;
	goal: graphql.EvaluationSubmissionGoal;
}) {
	const { localize } = useLocalize();
	const { goal } = props;
	const { t } = useTranslation();

	const review = props.item.reviewGoals?.find((review) => review.goalID === goal.goal.id);

	const label =
		review && review.competency !== undefined && review.competency !== null
			? localize(props.form.reviewGoals!.competencyLevelSet.levels[review.competency].title).text
			: t('conversations.evaluationSubmission.reviewGoals.noReview');

	return (
		<>
			<Paragraph>{t('review.goals.display.status')}:</Paragraph>
			<Subheading mb={2}>{label}</Subheading>
			<Box>
				<Paragraph>{t('review.goals.display.explanation')}:</Paragraph>
				<QuillText value={review?.text} />
			</Box>
		</>
	);
}
